import { InfoIcon, X } from "lucide-react";
import { useState, type FormEvent } from "react";

import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useAddDeck } from "@/hooks/useAddDeck";
import { useAllDecks } from "@/hooks/useAllDecks";

export const AddDeckDialogContent = () => {
  const decks = useAllDecks();
  const [deckName, setDeckName] = useState("");
  const [deckDescription, setDeckDescription] = useState("");
  const addDeck = useAddDeck();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    void addDeck({
      name: deckName,
      description: deckDescription,
    });
    setDeckName("");
    setDeckDescription("");
  };

  return (
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="text-xl">Create Deck</DialogTitle>
        <DialogClose className="absolute right-4 top-4 opacity-70 hover:opacity-100">
          <X className="h-4 w-4" />
        </DialogClose>
      </DialogHeader>
      <DialogDescription hidden={true}>
        Create a new deck with a title and optional description.
      </DialogDescription>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          placeholder="Deck name"
          value={deckName}
          onChange={(e) => setDeckName(e.target.value)}
        />

        {!decks?.length && (
          <div className="bg-gray-50 p-4 rounded-md">
            <div className="flex gap-3">
              <InfoIcon className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-semibold">Your first deck</h3>
                <p className="text-sm text-gray-600">
                  Unless you have a specific deck in mind, we always recommend creating a "Random"
                  deck for facts you'd like to remember long-term.
                </p>
              </div>
            </div>
          </div>
        )}

        <Textarea
          placeholder="Description (optional)"
          className="min-h-[100px]"
          value={deckDescription}
          onChange={(e) => setDeckDescription(e.target.value)}
        />

        <div className="flex justify-end">
          <DialogClose asChild>
            <Button type="submit">CREATE DECK</Button>
          </DialogClose>
        </div>
      </form>
    </DialogContent>
  );
};
